import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/articles';

export default function LatestSection() {
  const mainArticle = latestArticles[0];
  const gridArticles = latestArticles.slice(1, 4);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-4 lg:gap-16 mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 flex-shrink-0 leading-tight">
            最新<span className="text-primary-500">爆料</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-md leading-relaxed">
            实时追踪全网最新热点，从娱乐八卦到社会事件，第一时间为你呈现最劲爆的吃瓜资讯。
          </p>
        </div>

        {mainArticle && (
          <Link
            to={`/article/${mainArticle.slug}`}
            className="group block mb-6 cursor-pointer"
          >
            <div className="flex flex-col lg:flex-row gap-5 bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300">
              <div className="lg:w-[420px] h-[240px] lg:h-[280px] flex-shrink-0 overflow-hidden">
                <img
                  src={mainArticle.image}
                  alt={mainArticle.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <span className="self-start px-2.5 py-0.5 bg-primary-100 text-primary-700 text-xs rounded-full mb-3">
                  {mainArticle.categoryName}
                </span>
                <h3 className="font-heading text-lg md:text-2xl font-bold text-foreground-950 mb-3 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {mainArticle.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-4 line-clamp-2">
                  {mainArticle.excerpt}
                </p>
                <div className="flex items-center gap-4 text-foreground-400 text-xs">
                  <span>{mainArticle.author}</span>
                  <span>{mainArticle.date}</span>
                  <span><i className="ri-eye-line mr-1"></i>{(mainArticle.views / 10000).toFixed(1)}万阅读</span>
                </div>
              </div>
            </div>
          </Link>
        )}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {gridArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="h-[180px] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full mb-2">
                  {article.categoryName}
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-foreground-400 text-xs">
                  <span>{article.date}</span>
                  <span><i className="ri-eye-line mr-1"></i>{(article.views / 10000).toFixed(1)}万</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/yule-bagua"
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-foreground-200 rounded-full text-foreground-700 text-sm font-medium hover:border-primary-500 hover:text-primary-500 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多爆料 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}